// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form--sroll__prize[data-v-5e572db1] {\n  display: block;\n  overflow-y: auto;\n  overflow-x: hidden;\n  outline: none;\n}", ""]);
// Exports
module.exports = exports;
